/* global axios */
import ApiClient from './ApiClient';

const getTimezoneOffset = () => -new Date().getTimezoneOffset() / 60;

const normalizeInboxIds = inboxIds => {
  const ids = Array.isArray(inboxIds)
    ? inboxIds.map(Number).filter(Boolean)
    : [];
  if (!ids.length) return undefined;
  return ids.length === 1 ? ids[0] : ids;
};

class SLAReportsAPI extends ApiClient {
  constructor() {
    super('applied_slas', { accountScoped: true });
  }

  get({
    from,
    to,
    assigned_agent_id,
    inbox_ids = [],
    team_id,
    sla_policy_id,
    label_list,
    page,
  } = {}) {
    return axios.get(this.url, {
      params: {
        since: from,
        until: to,
        timezone_offset: getTimezoneOffset(),
        assigned_agent_id,
        inbox_id: normalizeInboxIds(inbox_ids),
        team_id,
        sla_policy_id,
        label_list,
        page,
      },
    });
  }

  download({
    from,
    to,
    assigned_agent_id,
    inbox_ids = [],
    team_id,
    sla_policy_id,
    label_list,
  } = {}) {
    return axios.get(`${this.url}/download`, {
      params: {
        since: from,
        until: to,
        timezone_offset: getTimezoneOffset(),
        assigned_agent_id,
        inbox_id: normalizeInboxIds(inbox_ids),
        team_id,
        label_list,
        sla_policy_id,
      },
    });
  }

  getMetrics({
    from,
    to,
    assigned_agent_id,
    inbox_ids = [],
    team_id,
    label_list,
    sla_policy_id,
  } = {}) {
    return axios.get(`${this.url}/metrics`, {
      params: {
        since: from,
        until: to,
        timezone_offset: getTimezoneOffset(),
        assigned_agent_id,
        inbox_id: normalizeInboxIds(inbox_ids),
        label_list,
        team_id,
        sla_policy_id,
      },
    });
  }

  getOverview({
    from,
    to,
    assigned_agent_id,
    inbox_ids = [],
    team_id,
    label_list,
    sla_policy_id,
    includeMeta = false,
  } = {}) {
    return axios.get(`${this.url}/overview`, {
      params: {
        since: from,
        until: to,
        timezone_offset: getTimezoneOffset(),
        assigned_agent_id,
        inbox_id: normalizeInboxIds(inbox_ids),
        label_list,
        team_id,
        sla_policy_id,
        ...(includeMeta ? { include_meta: true } : {}),
      },
    });
  }
}

export default new SLAReportsAPI();
